module.exports = __webpack_public_path__ + "img/huodong.0a34da24.png";